import {Paper} from "@mui/material";
import {useGetIntervalSessions} from "../services/ContentManager";
import {SESSIONS} from "../services/Client";
import React,{useState} from "react";
import SessionTable from "../components/tables/SessionTable";
import defaultIntervalSessions from "../constants/defaultIntervalSessions";

export function SessionManagement() {

    const defaultInterval = defaultIntervalSessions();
    let [interval, setInterval] = useState(defaultInterval)
    let {sessions = [], status} = useGetIntervalSessions(interval.start, interval.end);

    return <Paper style={{padding: "2rem"}}>
        <SessionTable sessions={sessions} loading={status === "loading"} interval={interval} setInterval={setInterval} queryKey={[SESSIONS, {start: interval.start, end: interval.end}]}/>
    </Paper>

}
